export default function convertEmptyStringToNull(value: string | null): string | null {
  return value?.length === 0 ? null : value;
}
